import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

const Callback = () => {
  const { handleCallback } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    handleCallback()
      .then(() => {
        const redirectTo = localStorage.getItem('auth_redirect') || '/onboarding';
        localStorage.removeItem('auth_redirect');
        navigate(redirectTo, { replace: true });
      })
      .catch((err) => {
        console.error('Callback error:', err);
        setError(err.errorDescription || err.message || 'Authentication failed');
      });
  }, [handleCallback, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center max-w-sm">
          <p className="text-red-400 text-sm mb-4">{error}</p>
          <button
            onClick={() => navigate('/login')}
            className="text-sm text-zinc-900 underline"
          >
            Back to login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-zinc-900 border-t-transparent rounded-full animate-spin" />
    </div>
  );
};

export default Callback;
